// Create singleton Map as store
export default new Map();

export const REQUEST_ID = Symbol('requestId');
export const USER_INFORMATION = Symbol('userInformation');
export const DRM_JWT = Symbol('drmJWT');
export const SEGMENT_HOST = Symbol('segmentHost');
export const IS_SHOWING_BREAKS = Symbol('isShowingBreaks');
export const PPID = Symbol('ppid');
export const SUBTITLES = Symbol('subtitles');
export const JWT_IS_INVALID = Symbol('JWTIsInvalid');
export const ENABLE_VCR = Symbol('EnableVCR');
export const CONTENT_ID = Symbol('ContentId');
